import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTopTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
}>;

export type GetTopTitlesQuery = { __typename?: 'Query' } & {
	movie: { __typename?: 'PopularTitlesConnection' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'PopularTitlesEdge' } & {
					node:
						| ({ __typename?: 'Movie' } & TopTitle_Movie_Fragment)
						| ({ __typename?: 'Show' } & TopTitle_Show_Fragment);
				}
			>
		>;
	};
	upcomingMovie: { __typename?: 'NewTitlesConnection' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'NewTitlesEdge' } & {
					node:
						| ({ __typename?: 'Movie' } & TopTitle_Movie_Fragment)
						| ({ __typename?: 'Season' } & TopTitle_Season_Fragment);
				}
			>
		>;
	};
	show: { __typename?: 'PopularTitlesConnection' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'PopularTitlesEdge' } & {
					node:
						| ({ __typename?: 'Movie' } & TopTitle_Movie_Fragment)
						| ({ __typename?: 'Show' } & TopTitle_Show_Fragment);
				}
			>
		>;
	};
	upcomingShow: { __typename?: 'NewTitlesConnection' } & {
		edges?: Types.Maybe<
			Array<
				{ __typename?: 'NewTitlesEdge' } & {
					node:
						| ({ __typename?: 'Movie' } & TopTitle_Movie_Fragment)
						| ({ __typename?: 'Season' } & TopTitle_Season_Fragment);
				}
			>
		>;
	};
};

export type TopTitle_Movie_Fragment = { __typename?: 'Movie' } & Pick<Types.Movie, 'id' | 'objectId' | 'objectType'> & {
		content: { __typename?: 'MovieContent' } & Pick<Types.MovieContent, 'title' | 'fullPath'>;
	};

export type TopTitle_Season_Fragment = { __typename?: 'Season' } & Pick<
	Types.Season,
	'id' | 'objectId' | 'objectType'
> & {
		show: { __typename?: 'Show' } & { content: { __typename?: 'ShowContent' } & Pick<Types.ShowContent, 'title'> };
		content: { __typename?: 'SeasonContent' } & Pick<Types.SeasonContent, 'title' | 'fullPath'>;
	};

export type TopTitle_Show_Fragment = { __typename?: 'Show' } & Pick<Types.Show, 'id' | 'objectId' | 'objectType'> & {
		content: { __typename?: 'ShowContent' } & Pick<Types.ShowContent, 'title' | 'fullPath'>;
	};

export type TopTitleFragment = TopTitle_Movie_Fragment | TopTitle_Season_Fragment | TopTitle_Show_Fragment;

export const TopTitleFragmentDoc = gql`
	fragment TopTitle on MovieOrShowOrSeason {
		id
		objectId
		objectType
		content(country: $country, language: $language) {
			title
			fullPath
		}
		... on Season {
			show {
				content(country: $country, language: $language) {
					title
				}
			}
		}
	}
`;
export const GetTopTitlesDocument = gql`
	query GetTopTitles($country: Country!, $language: Language!) {
		movie: popularTitles(country: $country, first: 5, filter: { objectTypes: MOVIE }) {
			edges {
				node {
					...TopTitle
				}
			}
		}
		upcomingMovie: newTitles(country: $country, first: 5, pageType: UPCOMING, filter: { objectTypes: MOVIE }) {
			edges {
				node {
					...TopTitle
				}
			}
		}
		show: popularTitles(country: $country, first: 5, filter: { objectTypes: SHOW }) {
			edges {
				node {
					...TopTitle
				}
			}
		}
		upcomingShow: newTitles(country: $country, first: 5, pageType: UPCOMING, filter: { objectTypes: SHOW_SEASON }) {
			edges {
				node {
					...TopTitle
				}
			}
		}
	}
	${TopTitleFragmentDoc}
`;
